var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "appointment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M40.359,28.729A1.523,1.523,0,0,0,42,27.234V9.844a6.57,6.57,0,0,0-6.562-6.563H33.3V1.641a1.641,1.641,0,0,0-3.281,0V3.281H22.559V1.641a1.641,1.641,0,1,0-3.281,0V3.281H11.895V1.641a1.641,1.641,0,1,0-3.281,0V3.281H6.562A6.57,6.57,0,0,0,0,9.844V35.438A6.57,6.57,0,0,0,6.562,42H35.438A6.57,6.57,0,0,0,42,35.438a1.641,1.641,0,1,0-3.281,0,3.285,3.285,0,0,1-3.281,3.281H6.562a3.285,3.285,0,0,1-3.281-3.281V9.844A3.285,3.285,0,0,1,6.562,6.563H8.613V8.2a1.641,1.641,0,1,0,3.281,0V6.563h7.383V8.2a1.641,1.641,0,1,0,3.281,0V6.563h7.465V8.2a1.641,1.641,0,1,0,3.281,0V6.563h2.133a3.285,3.285,0,0,1,3.281,3.281V27.234A1.523,1.523,0,0,0,40.359,28.729Z",
    fill: "#f6781b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M167.793,216.586a1.641,1.641,0,0,0,1.641-1.641v-4.512h4.512a1.641,1.641,0,0,0,0-3.281h-4.512v-4.512a1.641,1.641,0,0,0-3.281,0v4.512h-4.512a1.641,1.641,0,0,0,0,3.281h4.512v4.512A1.641,1.641,0,0,0,167.793,216.586Z",
    transform: "translate(-146.875 -184.512)",
    fill: "#003358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M33.353,23.838h3.3V34.861h-3.3Z",
    transform: "translate(5.346 0.874)",
    fill: "#f6781b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.95fd8f6ce896659227515a0f4c2e506d.svg";
export { ForwardRef as ReactComponent };